import { Schema } from 'effect';

export const DateSerializable = Schema.TaggedStruct('Date', {
  value: Schema.String,
});

export type DateSerializable = Schema.Schema.Type<typeof DateSerializable>;
